/**
 * Algolia Configuration
 * Centralized configuration for Algolia search integration
 */
(function() {
  'use strict';

  // Initialize global config namespace
  window.algoliaThemeConfig = {
    /**
     * Feature flags
     */
    features: {
      debug: false,  // Set to true to enable console logging
      mobileAutocomplete: false,  // Disable autocomplete on mobile
    },

    /**
     * Collection IDs
     */
    collections: {
      bestSellers: 272070508590,
    },

    /**
     * Search settings
     */
    search: {
      fallbackLimit: 12,  // Number of fallback products to show
      priceInCents: false,  // Set to true if your index stores prices in cents
    },

    /**
     * Responsive breakpoints (should match CSS)
     */
    breakpoints: {
      mobile: 767.98,
      tablet: 1171,
      desktop: 1280,
    },

    /**
     * Predefined search suggestions
     * Update these seasonally or based on marketing campaigns
     */
    predefinedLinks: [
      {
        label: 'New Arrivals',
        url: '/collections/new-arrivals'
      },
      {
        label: 'Beds',
        url: '/search?q=beds'
      },
      {
        label: 'Tablecloth',
        url: '/search?q=tablecloth'
      },
      {
        label: 'Game Table',
        url: '/search?q=game+table'
      },
      {
        label: 'Console',
        url: '/search?q=console'
      },
      {
        label: 'Pillows',
        url: '/search?q=pillows'
      },
      {
        label: 'Side Table',
        url: '/search?q=side+table'
      },
    ],

    /**
     * Product tags configuration
     */
    tags: {
      new: 'New',  // Tag that marks products as "new"
      freeShipping: 'Free Shipping',  // Tag for free shipping
      personalized: ['Personalized', 'Monogram Shop'],  // Tags for personalized items
    },

    /**
     * Promotion settings (populated from Shopify theme settings)
     */
    promotion: {
      enabled: false,
      promotions: []
    },

    /**
     * UI Text
     */
    text: {
      searchPlaceholder: 'Search...',
      popularSearches: 'Popular searches',
      productSuggestions: 'Product Suggestions',
      quickBuy: 'Quick buy',
      quickView: 'Quick View',
      shopBestSellers: 'Shop Best Sellers',
      popularInBestSellers: 'Popular in Best sellers',
    },

    /**
     * Gallery/Slick settings
     */
    gallery: {
      observer: {
        rootMargin: '200px 0px 200px 0px',
      },
      slick: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: false,
        adaptiveHeight: false,
        swipe: true,
        swipeToSlide: true,
        speed: 200,
        touchThreshold: 10,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              dots: true,
              arrows: false,
            }
          }
        ]
      }
    },

    /**
     * Helper function to get full URL
     * @param {string} path - Relative path
     * @returns {string} Full URL
     */
    getUrl: function(path) {
      const root = window.Shopify?.routes?.root || '/';
      return root + path.replace(/^\//, '');
    },

    /**
     * Helper function to check if mobile
     * @returns {boolean} True if mobile viewport
     */
    isMobile: function() {
      return window.matchMedia(`(max-width: ${this.breakpoints.mobile}px)`).matches;
    },

    /**
     * Debug logger
     * @param  {...any} args - Arguments to log
     */
    log: function(...args) {
      if (this.features.debug) {
        console.log('[Algolia]', ...args);
      }
    },

    /**
     * Error logger (always logs)
     * @param  {...any} args - Arguments to log
     */
    error: function(...args) {
      console.error('[Algolia Error]', ...args);
    }
  };

  // Initialize promotion settings from Shopify theme settings
  if (window.shopifyThemeSettings && window.shopifyThemeSettings.promotion) {
    window.algoliaThemeConfig.promotion = window.shopifyThemeSettings.promotion;
  }

  // Make config read-only (optional, prevents accidental modifications)
  if (Object.freeze) {
    Object.freeze(window.algoliaThemeConfig.collections);
    Object.freeze(window.algoliaThemeConfig.breakpoints);
    Object.freeze(window.algoliaThemeConfig.tags);
    Object.freeze(window.algoliaThemeConfig.text);
  }
})();
